/**
 * Action Registry Initialization
 * Registers all entity actions with the central registry
 * Called once at application startup
 */

import { registerEntityActions } from "./registry/EntityActionMap";
import {
  contactDetailActions,
  taskDetailActions,
  ticketDetailActions,
  companyDetailActions,
  dealDetailActions,
  communicationDetailActions,
  timeEntryDetailActions,
  contractDetailActions,
  userDetailActions,
} from "./definitions";

/**
 * Initialize all entity actions in the registry
 * This function should be called once during application startup
 */
export function initializeAllEntityActions(): void {
  // Register contact actions
  registerEntityActions("contacts", () => contactDetailActions);

  // Register task actions
  registerEntityActions("tasks", () => taskDetailActions);

  // Register ticket actions
  registerEntityActions("tickets", () => ticketDetailActions);

  // Register company actions
  registerEntityActions("companies", () => companyDetailActions);

  // Register deal actions
  registerEntityActions("deals", () => dealDetailActions);

  // Register communication actions
  registerEntityActions("communications", () => communicationDetailActions);

  // Register time entry actions
  registerEntityActions("time_entries", () => timeEntryDetailActions);

  // Register contract actions
  registerEntityActions("contracts", () => contractDetailActions);

  // Register user actions
  registerEntityActions("users", () => userDetailActions);

  // TODO: Register remaining entities (employees, etc.)
}
